import { useState, useEffect, Fragment } from "react";

interface WordByWordRevealProps {
  text: string;
  className?: string;
  startDelay?: number;
  wordDelay?: number;
  as?: "h1" | "p" | "span";
}

export const WordByWordReveal = ({ 
  text, 
  className = "",
  startDelay = 1000,
  wordDelay = 100,
  as: Tag = "h1"
}: WordByWordRevealProps) => {
  const [visibleWords, setVisibleWords] = useState(0);
  const words = text.split(' ');

  useEffect(() => {
    const startTimer = setTimeout(() => {
      words.forEach((_, index) => {
        setTimeout(() => {
          setVisibleWords(index + 1);
        }, index * wordDelay);
      });
    }, startDelay);

    return () => clearTimeout(startTimer);
  }, [text, startDelay, wordDelay]);

  return (
    <Tag className={className}>
      {words.map((word, index) => (
        <Fragment key={index}>
        {index > 0 && " "}
        <span
          className="inline-block"
          style={{
            opacity: index < visibleWords ? 1 : 0,
            transform: index < visibleWords ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
            filter: index < visibleWords ? 'blur(0)' : 'blur(4px)',
            transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          {word}
        </span>
        </Fragment>
      ))}
    </Tag>
  );
};
